export default {
  nav: {
    howItWorks: 'Comment ça marche',
    signIn: 'Connexion',
    startFree: 'Nous contacter →',
  },

  hero: {
    badge: 'Conçu pour les gérants de salles',
    title1: 'La plateforme tout-en-un',
    title2: 'pour les gérants de salles',
    desc: 'Gérez vos adhérents, abonnements, cours, coachs, pointages et revenus — depuis un seul tableau de bord. Fini les tableaux Excel et les cahiers papier.',
    cta: 'Nous contacter →',
    ctaSub: 'Voir comment ça marche',
    fine: 'Démo personnalisée · Accompagnement à la mise en route',
  },

  howItWorks: {
    eyebrow: 'Mise en place simple',
    title: 'Opérationnel en moins de 10 minutes',
    steps: [
      { num: '01', title: 'Contactez-nous', desc: 'Notre équipe configure votre salle pour vous : nom, coordonnées et préférences. Aucune configuration technique de votre côté.' },
      { num: '02', title: 'Configurez vos offres', desc: 'Définissez vos formules d\'abonnement avec les tarifs, la durée et les avantages inclus. Créez votre planning de cours et votre équipe de coachs.' },
      { num: '03', title: 'Ajoutez vos adhérents', desc: 'Importez vos membres existants ou ajoutez-les un par un. Chaque adhérent reçoit un QR code unique pour le pointage.' },
      { num: '04', title: 'Gérez votre salle', desc: 'Pointages quotidiens, suivi des renouvellements, réservations de coaching, encaissements — tout depuis un seul tableau de bord.' },
    ],
    ctaTitle: 'Prêt à moderniser votre salle ?',
    ctaDesc: 'Rejoignez les salles qui utilisent déjà UbiGym pour développer leur activité.',
    ctaBtn: 'Nous contacter →',
  },

  footer: {
    desc: 'La plateforme de gestion de salle de sport tout-en-un pour les gérants de salles modernes.',
    email: 'contact@ubigym.ma',
    product: 'Produit',
    account: 'Compte',
    legal: 'Légal',
    links: {
      howItWorks: 'Comment ça marche',
      signIn: 'Se connecter',
      contact: 'Nous contacter',
      privacy: 'Politique de confidentialité',
      terms: 'Conditions d\'utilisation',
      cookies: 'Politique cookies',
    },
    rights: 'Tous droits réservés.',
    madeFor: 'Fait pour les gérants de salles 🏋️',
  },
}
